import { Button, OverlayTrigger, Tooltip, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/pro-light-svg-icons';
import { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../components/Modal/index';
import '../styles/addStudentFloatingBar.scss';

const AddStudentFloatingBar = ({ selectedStudents, handleCheckBoxChange, handleAddStudent }) => {
  const [showSelectedStudentsModal, setShowSelectedStudentsModal] = useState(false);

  return (
    <>
      <div>
        <div className="selectionDetailsBar">
          <div className='d-flex align-items-center gap-2'>
            <div>Selected</div>
            <div className='selectionTypeCount'>{selectedStudents ? selectedStudents.length : 0}</div>
            <OverlayTrigger
              key="editToolTip"
              placement="top"
              overlay={<Tooltip className="custom-tooltip">View all selected students</Tooltip>}>
              <div className='selectedStudentsClipboard' onClick={() => setShowSelectedStudentsModal(true)}><FontAwesomeIcon icon={faClipboardList} /></div>
            </OverlayTrigger>
          </div>
          <div>
            <Button variant='castleRed' disabled={!(selectedStudents?.length) > 0} onClick={() => handleAddStudent()}>Add Students</Button>
          </div>
        </div>
      </div>


      <Modal
        isOpen={showSelectedStudentsModal}
        onClose={() => setShowSelectedStudentsModal(false)}
        titleName={'Selected Students'}
        contentWidth={'60%'}>
        <Table className='table reportTable'>
          <thead className='thead-light align-middle thead-fixed'>
            <tr>
              <th>
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value=""
                    id="assignCheckClipboard"
                    name="assignCheckClipboard"
                    checked={
                      selectedStudents.length > 0 && selectedStudents.filter((item) => item?.isChecked !== true && !item.existsInClass).length < 1
                    }
                    onChange={handleCheckBoxChange}
                    disabled={selectedStudents.length <= 0}
                  />
                </div>
              </th>
              <th scope="col" className='fw-medium'>
                <span className='align-items-center'> <span>Last Name</span> </span>
              </th>
              <th scope="col" className='fw-medium'>
                <span className='align-items-center'><span>First Name</span></span>
              </th>
              <th scope="col" className='fw-medium mw-200 transparent-scroll'>
                <span className='align-items-center'><span>Login</span></span>
              </th>
              <th scope="col" className='fw-medium'>
                <span className='align-items-center'><span>Id</span></span>
              </th>
              <th scope="col" className='fw-medium'>
                <span className='align-items-center'><span>Category</span></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedStudents?.map((student) => (
              <tr key={`record_${student.studentId}`}>
                <td className='d-flex'>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      value=""
                      name={student.studentId}
                      checked={student?.isChecked}
                      onChange={handleCheckBoxChange}
                      className="form-check-input"
                      id={`flexCheckDefault-${student.studentId}`}
                    />
                  </div>
                </td>
                <td>{student.lName}</td>
                <td>{student.fName}</td>
                <td className='mw-200 transparent-scroll overflow-auto'>{student.login}</td>
                <td>{student.identification}</td>
                <td>{student.code}</td>
              </tr>
            ))}
            {selectedStudents?.length == 0 && <tr>
              <td colSpan='5' className='p-3 text-danger'>There are no selected students.</td>
            </tr>}
          </tbody>
        </Table>


      </Modal>
    </>
  );
};

AddStudentFloatingBar.propTypes = {
  selectedStudents: PropTypes.array.isRequired,
  handleCheckBoxChange: PropTypes.func,
  handleAddStudent: PropTypes.func.isRequired
};

export default AddStudentFloatingBar;